import { render } from "./AccountConfirmation.vue?vue&type=template&id=f12ea47c&scoped=true"
import script from "./AccountConfirmation.vue?vue&type=script&lang=js"
export * from "./AccountConfirmation.vue?vue&type=script&lang=js"

import "./AccountConfirmation.vue?vue&type=style&index=0&id=f12ea47c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f12ea47c"]])

export default __exports__